import {
    ADMIN_GET_ALL_USER,
    ADMIN_GET_ALL_USER_APPLY,
    ADMIN_GET_USER_DETAIL,
    ADMIN_GET_USER_AGENDA,
    ADMIN_GET_USER_DIARY,
    ADMIN_GET_USER_PRACTICE,
    ADMIN_GET_AGENDA_COUNSELLOR,
    ADMIN_GET_ROOMS,

} from '../actions/actionTypes'

const initialState = {
    data: [],
    isFailed: false,
    isLoading: false
}

export function adminGetProfile(state = initialState, action) {
    switch (action.type) {
        case ADMIN_GET_USER_DETAIL.REQUEST:
            return { ...state, isFailed: false, data: null, isLoading: true };
        case ADMIN_GET_USER_DETAIL.SUCCESS:
            return { ...state, isFailed: false, data: action.payload, isLoading: false };
        case ADMIN_GET_USER_DETAIL.FAILURE:
            return { ...state, isFailed: true, data: action.payload, isLoading: false };
        default:
            return state
    }
}


export function adminGetAllUser(state = initialState, action) {
    switch (action.type) {
        case ADMIN_GET_ALL_USER.REQUEST:
            return { ...state, isFailed: false, data: null, isLoading: true };
        case ADMIN_GET_ALL_USER.SUCCESS:
            return { ...state, isFailed: false, data: action.payload, isLoading: false };
        case ADMIN_GET_ALL_USER.FAILURE:
            return { ...state, isFailed: true, data: action.payload, isLoading: false };
        default:
            return state
    }
}

export function adminGetAllUserApply(state = initialState, action) {
    switch (action.type) {
        case ADMIN_GET_ALL_USER_APPLY.REQUEST:
            return { ...state, isFailed: false, data: null, isLoading: true };
        case ADMIN_GET_ALL_USER_APPLY.SUCCESS:
            return { ...state, isFailed: false, data: action.payload, isLoading: false };
        case ADMIN_GET_ALL_USER_APPLY.FAILURE:
            return { ...state, isFailed: true, data: action.payload, isLoading: false };
        default:
            return state
    }
}

export function adminGetUserAgenda(state = initialState, action) {
    switch (action.type) {
        case ADMIN_GET_USER_AGENDA.REQUEST:
            return { ...state, isFailed: false, data: null, isLoading: true };
        case ADMIN_GET_USER_AGENDA.SUCCESS:
            return { ...state, isFailed: false, data: action.payload, isLoading: false };
        case ADMIN_GET_USER_AGENDA.FAILURE:
            return { ...state, isFailed: true, data: action.payload, isLoading: false };
        default:
            return state
    }
}
export function adminGetAgendaOfCounsellor(state = initialState, action) {
    switch (action.type) {
        case ADMIN_GET_AGENDA_COUNSELLOR.REQUEST:
            return { ...state, isFailed: false, data: null, isLoading: true };
        case ADMIN_GET_AGENDA_COUNSELLOR.SUCCESS:
            return { ...state, isFailed: false, data: action.payload, isLoading: false };
        case ADMIN_GET_AGENDA_COUNSELLOR.FAILURE:
            return { ...state, isFailed: true, data: action.payload, isLoading: false };
        default:
            return state
    }
}

export function adminGetUserDiary(state = initialState, action) {
    switch (action.type) {
        case ADMIN_GET_USER_DIARY.REQUEST:
            return { ...state, isFailed: false, data: null, isLoading: true };
        case ADMIN_GET_USER_DIARY.SUCCESS:
            return { ...state, isFailed: false, data: action.payload, isLoading: false };
        case ADMIN_GET_USER_DIARY.FAILURE:
            return { ...state, isFailed: true, data: action.payload, isLoading: false };
        default:
            return state
    }
}

export function adminGetUserPractice(state = initialState, action) {
    switch (action.type) {
        case ADMIN_GET_USER_PRACTICE.REQUEST:
            return { ...state, isFailed: false, data: null, isLoading: true };
        case ADMIN_GET_USER_PRACTICE.SUCCESS:
            return { ...state, isFailed: false, data: action.payload, isLoading: false };
        case ADMIN_GET_USER_PRACTICE.FAILURE:
            return { ...state, isFailed: true, data: action.payload, isLoading: false };
        default:
            return state
    }
}

export function adminGetRooms(state = initialState, action) {
    switch (action.type) {
        case ADMIN_GET_ROOMS.REQUEST:
            return { ...state, isFailed: false, data: null, isLoading: true };
        case ADMIN_GET_ROOMS.SUCCESS:
            return { ...state, isFailed: false, data: action.payload, isLoading: false };
        case ADMIN_GET_ROOMS.FAILURE:
            return { ...state, isFailed: true, data: action.payload, isLoading: false };
        default:
            return state
    }
}

export function userGetRooms(state = initialState, action) {
    switch (action.type) {
        case ADMIN_GET_ROOMS.REQUEST:
            return { ...state, isFailed: false, data: null, isLoading: true };
        case ADMIN_GET_ROOMS.SUCCESS:
            return { ...state, isFailed: false, data: action.payload, isLoading: false };
        case ADMIN_GET_ROOMS.FAILURE:
            return { ...state, isFailed: true, data: action.payload, isLoading: false };
        default:
            return state
    }
}